import { useMutation } from '@tanstack/react-query';

import { getBookingEndpoint } from 'reservations/base/constants/endpoints';
import { useModal } from 'reservations/base/providers/ModalProvider';
import { useBookingId } from 'reservations/booking/providers/BookingProvider';
import {
  type BookingMutationResponse,
  BookingMutationResponseSchema
} from 'reservations/booking/types';
import { restClient } from 'utility/restClient';
import type { RequestError } from 'utility/restClient';

export const useUnenrollChecklessMutation = () => {
  const bookingId = useBookingId();
  const { close } = useModal();

  return useMutation<BookingMutationResponse, RequestError>({
    mutationKey: ['UNENROLL_CHECKLESS'],
    mutationFn: async () => {
      const endpoint = getBookingEndpoint(bookingId, 'checkless');
      const response = await restClient.delete(endpoint);

      try {
        return BookingMutationResponseSchema.parse(response);
      } catch (err) {
        console.error('useUnenrollChecklessMutation: ', err);
        throw err;
      }
    },
    onSuccess: _data => {
      close();
    }
  });
};
